import React from 'react';
import { CircleAlert } from 'lucide-react';

export function VideoLoadError(): React.JSX.Element {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-[400px] text-center"
      role="alert"
      aria-live="polite"
    >
      <CircleAlert
        size={60}
        className="text-primary mb-4"
        strokeWidth={1.5}
      />
      <p className="font-medium text-high-emphasis-font mb-2">
        Video unavailable
      </p>
      <p className="font-normal text-font-700">
        There was an unexpected error loading your video. Please try again later.
      </p>
    </div>
  );
}
